import { useNavigate, useLocation } from "react-router-dom";
import axios from "axios";
import "./AdminLayout.css";
import {
  LayoutDashboard,
  Layers,
  ShoppingCart,
  Package,
  User,
  Settings,
  LogOut,
  Tag,
  Grid,
} from "lucide-react"; // optional icons

const AdminLayout = ({ children }) => {
  const navigate = useNavigate();
  const location = useLocation();

  const sidebarLinks = [
    { name: "Dashboard", href: "/Dashbord", icon: <LayoutDashboard size={18} /> },
    { name: "Add Category", href: "/addcategory", icon: <Grid size={18} /> },
    { name: "Category List", href: "/listCategory", icon: <Grid size={18} /> },
    { name: "Add SubCategory", href: "/addSubCategory", icon: <Layers size={18} /> },
    { name: "SubCategory List", href: "/listSubCategory", icon: <Layers size={18} /> },
    { name: "Add Variant", href: "/addVariant", icon: <Tag size={18} /> },
    { name: "Variant List", href: "/listVariant", icon: <Tag size={18} /> },
    { name: "Add Brand", href: "/addBrand", icon: <Package size={18} /> },
    { name: "Brand List", href: "/listBrand", icon: <Package size={18} /> },
    { name: "Product List", href: "/adminProductList", icon: <ShoppingCart size={18} /> },
    { name: "Order List", href: "/adminOrderList", icon: <ShoppingCart size={18} /> },
    { name: "Seller List", href: "/sellerList", icon: <User size={18} /> },
    { name: "Contact List", href: "/contactList", icon: <Settings size={18} /> },
  ];

  const logout = async () => {
  try {
    await axios.get(`${process.env.REACT_APP_API_URL}/api/admin/logout`, {
      withCredentials: true,
    });

    // Clear any cached routes
    window.history.replaceState(null, "", "/");
    navigate("/", { replace: true });

    // Force re-render to clear React memory
    window.location.reload();
  } catch (err) {
    console.error("Logout failed:", err);
    navigate("/", { replace: true });
  }
};



  return (
    <div className="admin-dashboard">
      {/* Sidebar */}
      <aside className="admin-sidebar">
        <div className="sidebar-header">
          <h2 style={{color:
            'white'
          }}>🛍️ Multi-Vendor</h2>
          <p>Admin Panel</p>
        </div>
        <ul className="sidebar-links">
          {sidebarLinks.map((link, index) => {
            const isActive = location.pathname === link.href;
            return (
              <li key={index} className={isActive ? "active" : ""}>
                <a href={link.href}>
                  {link.icon}
                  <span>{link.name}</span>
                </a>
              </li>
            );
          })}
        </ul>
      </aside>

      {/* Main Area */}
      <div className="admin-main">
        <header className="admin-header">
          <h3>Welcome, Administrator</h3>
          <button className="logout-btn" onClick={logout}>
            <LogOut size={18} /> Logout
          </button>
        </header>

        <main className="admin-content">{children}</main>
      </div>
    </div>
  );
};

export default AdminLayout;
